<ng-container *transloco="let t">
  <div class="px-3 py-2 teal-50-bg header-alt-container">
    <app-grid-item-title [title]="title"/>
  </div>
</ng-container>
